import React from 'react';
import { ContributionBar } from '../contribution_bar/contribution_bar';
import { Stack } from '../Stack/Stack';
import { formatPercentage } from '../../util/formatters';

type ContributionData = Omit<React.ComponentProps<typeof ContributionBar>, 'color'>;

interface Props {
  data: ContributionData[];
  hidePercentage?: boolean;
}

export function ContributionListChart({ data, hidePercentage }: Props): JSX.Element {
  return (
    <Stack size="md">
      {data.map((item, index) => {
        const label = [
          item.label,
          hidePercentage
            ? ''
            : [
                ' ',
                item.percentage < 0.001 ? '(< ' : '(',
                formatPercentage(item.percentage < 0.001 ? 0.001 : item.percentage),
                ')',
              ].join(''),
        ].join('');

        return (
          <ContributionBar
            key={index}
            percentage={normalizePercentage(item.percentage)}
            label={label}
            value={item.value}
            color={cycleColors(index)}
            href={item.href}
          />
        );
      })}
    </Stack>
  );
}

function normalizePercentage(value: number): number {
  if (value <= 0) return 0;
  if (value > 1) return 1;

  const percentValue = value * 100;

  const minVisible = 5; // Minimum visible percentage
  const scalingFactor = 0.4; // Value between 0-1: lower = more boost, higher = less boost

  const logValue = Math.log10(1 + percentValue * scalingFactor);
  const maxLogValue = Math.log10(1 + 100 * scalingFactor);

  const normalized = logValue / maxLogValue;

  return minVisible + (100 - minVisible) * normalized;
}

const colors = [
  '#2D9CDB',
  '#EB5757',
  '#676767',
  '#F2C94C',
  '#6FCF97',
  '#247DAF',
  '#C14646',
  '#525252',
  '#C6A43D',
  '#5AA97B',
  '#1B5E83',
  '#963535',
  '#3E3E3E',
  '#9A7F2E',
  '#45835F',
  '#123E58',
  '#6C2525',
  '#292929',
  '#6D5A20',
  '#305D42',
  '#0E2F42',
  '#571C1C',
  '#1F1F1F',
  '#574818',
  '#264A34',
  '#0E2F42',
  '#571C1C',
  '#1F1F1F',
  '#574818',
  '#264A34',
  '#000',
];

function cycleColors(index: number): string {
  return colors[index % colors.length];
}
